module.exports = __webpack_public_path__ + "122e86ab361184b4f738463bc8da3b6d.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/power_has_a_price-1050.webp.png
// module id = 506
// module chunks = 0